import script from "./hotGoods.vue?vue&type=script&setup=true&lang=ts"
export * from "./hotGoods.vue?vue&type=script&setup=true&lang=ts"

import "./hotGoods.vue?vue&type=style&index=0&id=7187547b&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/bj-International-card-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7187547b"]])

export default __exports__